<!--
Copyright (c) 2022-2023 Antmicro <www.antmicro.com>

SPDX-License-Identifier: Apache-2.0
-->

<!-- eslint-disable max-len -->
<template>
    <svg
        :class="rotate"
        width="6"
        height="20"
        viewBox="0 0 6 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4.60743 12.3272C4.60743 13.2085 3.89295 13.923 3.01159 13.923V13.923C2.13023 13.923 1.41574 13.2085 1.41574 12.3272L1.41575 1.88397C1.41575 1.00261 2.13023 0.288122 3.01159 0.288122V0.288122C3.89295 0.288122 4.60744 1.00261 4.60744 1.88397L4.60743 12.3272ZM2.99882 16.17C3.57758 16.17 4.06272 16.3487 4.45423 16.7062C4.84575 17.0807 5.0415 17.5403 5.0415 18.085C5.0415 18.6297 4.84575 19.0808 4.45423 19.4383C4.06272 19.8128 3.57758 20 2.99882 20C2.42006 20 1.93493 19.8213 1.54341 19.4638C1.1519 19.1233 0.956141 18.6893 0.956141 18.1616C0.956141 17.5998 1.1519 17.1232 1.54341 16.7317C1.9179 16.3572 2.40304 16.17 2.99882 16.17Z"
            fill="white"
        />
    </svg>
</template>

<script>
export default {
    props: {
        rotate: {
            type: String,
            required: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.flip {
    rotate: 180deg;
}
</style>
